<div class="page">
  <div class="header-row">
    <div class="title-group">
      <h1>Detalhes do Anúncio</h1>
      <p class="subtitle">Visualize informações, métricas e status do anúncio.</p>
    </div>

    <div class="actions">
      <a class="btn btn-ghost" routerLink="/home">Voltar</a>
      <a *ngIf="ad()?.status !== 'finished'" [routerLink]="['/ads', ad()?.id, 'editar']" class="btn btn-primary">Editar</a>
    </div>
  </div>

  @if (loading()) {
    <div class="loading">Carregando...</div>
  } @else if (error()) {
    <div class="error">{{ error() }}</div>
  } @else {
    <div class="card">
      <div class="card-header">
        <div>
          <h2>{{ ad()?.title }}</h2>
          <div class="meta">
            <small class="meta-item">ID: {{ ad()?.id }}</small>
            <small class="meta-item">Público: {{ ad()?.target === 'user' ? 'Usuário' : 'Loja' }}</small>
          </div>
        </div>

        <span class="badge" [class]="'badge--' + statusKey(ad()?.status || '')">
          {{ getStatusLabel(ad()?.status) }}
        </span>
      </div>

      <div class="card-content">
        @if (ad()?.image_url) {
          <div class="image-container">
            <img [src]="ad()?.image_url" [alt]="ad()?.title" class="ad-image">
          </div>
        }

        <div class="details-grid">
          <div class="detail-item full">
            <span class="label">Texto</span>
            <p class="value">{{ ad()?.text }}</p>
          </div>

          <div class="detail-item">
            <span class="label">URL de Redirecionamento</span>
            <a [href]="ad()?.url_redirect" target="_blank" class="value link">{{ ad()?.url_redirect }}</a>
          </div>

          <div class="detail-item">
            <span class="label">Valor</span>
            <span class="value">{{ formatMoney(ad()?.value) }}</span>
          </div>

          <div class="detail-item">
            <span class="label">Período de Exibição</span>
            <span class="value">{{ formatDate(ad()?.show_from) }} - {{ formatDate(ad()?.show_until) }}</span>
          </div>

          <div class="metrics">
            <span class="pill">👁 {{ ad()?.views || 0 }} visualizações</span>
            <span class="pill">🖱 {{ ad()?.clicks || 0 }} cliques</span>
          </div>

          @if (ad()?.status === 'blocked' && ad()?.error_message) {
            <div class="error-message">
              <strong>Motivo do Bloqueio:</strong> {{ ad()?.error_message }}
            </div>
          }
        </div>
      </div>

      <div class="card-actions">
        @if (ad()?.status === 'created') {
          <button class="btn btn-primary" (click)="openPaymentModal()" [disabled]="paymentLoading()">
            Pagar
          </button>
        } @else if (ad()?.status !== 'finished') {
          <a [routerLink]="['/ads', ad()?.id, 'editar']" class="btn btn-primary">Editar Anúncio</a>
        }
      </div>
    </div>

    <!-- Payment Modal -->
    @if (showPaymentModal()) {
      <div class="modal-overlay" (click)="closePaymentModal()">
        <div class="modal" (click)="$event.stopPropagation()">
          <div class="modal-header">
            <h3>Escolha a forma de pagamento</h3>
            <button class="close-btn" (click)="closePaymentModal()">✕</button>
          </div>

          @if (paymentError()) {
            <div class="modal-error">{{ paymentError() }}</div>
          }

          <div class="modal-content">
            @if (!pixData()) {
              <div class="payment-options">
                <button class="payment-btn" (click)="requestPixQrCode()" [disabled]="paymentLoading()">
                  <div class="payment-icon">📱</div>
                  <div class="payment-label">PIX QR Code</div>
                </button>
                <button class="payment-btn" (click)="openCreditCardForm()" [disabled]="paymentLoading()">
                  <div class="payment-icon">💳</div>
                  <div class="payment-label">Cartão de Crédito</div>
                </button>
              </div>
            }

            @if (pixData()) {
              <div class="pix-container">
                <div class="pix-image">
                  <img [src]="'data:image/png;base64,' + pixData()?.EncodedImage" alt="QR Code PIX">
                </div>
                <div class="pix-code">
                  <span class="label">Código PIX (copiar e colar):</span>
                  <div class="code-display">
                    <code>{{ pixData()?.Payload }}</code>
                    <button class="copy-btn" (click)="copyPixCode()">Copiar</button>
                  </div>
                </div>
                <div class="pix-expiration">
                  <small>Válido até: {{ pixData()?.ExpirationDate | date:'dd/MM/yyyy HH:mm:ss' }}</small>
                </div>
              </div>
            }

            @if (showCreditCardForm()) {
              <div class="credit-card-form">
                <div class="form-group">
                  <label>Número do Cartão</label>
                  <input type="text" [(ngModel)]="creditCardForm.cardNumber" placeholder="0000 0000 0000 0000" maxlength="19" />
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label>Validade</label>
                    <div class="expiry">
                      <input type="text" [(ngModel)]="creditCardForm.expirationMonth" placeholder="MM" maxlength="2" class="half" />
                      <span class="sep">/</span>
                      <input type="text" [(ngModel)]="creditCardForm.expirationYear" placeholder="AA" maxlength="2" class="half" />
                    </div>
                  </div>
                  <div class="form-group">
                    <label>CVV</label>
                    <input type="text" [(ngModel)]="creditCardForm.cvv" placeholder="000" maxlength="4" />
                  </div>
                </div>

                <div class="form-group">
                  <label>Nome do Titular</label>
                  <input type="text" [(ngModel)]="creditCardForm.holderName" placeholder="JOÃO DA SILVA" />
                </div>

                <div class="form-group">
                  <label>CPF/CNPJ</label>
                  <input type="text" [(ngModel)]="creditCardForm.cpfCnpj" placeholder="000.000.000-00" />
                </div>

                <div class="form-group">
                  <label>Email</label>
                  <input type="email" [(ngModel)]="creditCardForm.email" placeholder="seu@email.com" />
                </div>

                <div class="form-actions">
                  <button class="btn btn-ghost" (click)="closePaymentModal()">Voltar</button>
                  <button class="btn btn-primary" (click)="submitCreditCard()" [disabled]="paymentLoading()">
                    {{ paymentLoading() ? 'Processando...' : 'Pagar' }}
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  }
</div>

